import React, { useState, useRef, useEffect } from "react";
import { Card, Table, Dropdown, Form } from "react-bootstrap";
import { FiEdit2, FiTrash2, FiCalendar } from "react-icons/fi";
// import EditActivityModal from "../../modals/activity/EditActivityModal";
import DeleteModal from "../../modals/activity/DeleteModal";
import { Pagination } from "react-bootstrap";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import EditActivityModal from "../../modals/activity/edit/EditActivityModal";
const ActivityTable = () => {
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);

const ref = useRef();

  const options = [
    { label: "Today", range: "04/05/2026 - 04/05/2026" },
    { label: "Yesterday", range: "04/04/2026 - 04/04/2026" },
    { label: "Last 7 Days", range: "03/30/2026 - 04/05/2026" },
    { label: "Last 30 Days", range: "03/06/2026 - 04/05/2026" },
  ];

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(options[2]); // default
  const [dateRange, setDateRange] = useState(options[2].range);

  // close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);


   const totalItems = 11;
  const itemsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem =
    currentPage * itemsPerPage > totalItems
      ? totalItems
      : currentPage * itemsPerPage;

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const data = [
    {
      title: "We scheduled a meeting for next week",
      type: "Meeting",
      due: "16 Jan 2024",
      owner: "Hendry Milner",
      created: "14 Jan 2024",
    },
    {
      title: "Had conversation with Fred regarding task",
      type: "Calls",
      due: "24 Jan 2024",
      owner: "Guilory Berggren",
      created: "21 Jan 2024",
    },
     {
    title: "We scheduled a meeting for next week",
    type: "Meeting",
    due: "16 Jan 2024",
    owner: "Hendry Milner",
    created: "14 Jan 2024",
  },
  {
    title: "Followed up with client regarding proposal",
    type: "Calls",
    due: "18 Jan 2024",
    owner: "Sophia Carter",
    created: "15 Jan 2024",
  },
  {
    title: "Sent marketing email campaign to leads",
    type: "Emails",
    due: "20 Jan 2024",
    owner: "Daniel Brooks",
    created: "18 Jan 2024",
  },
  {
    title: "Prepared project task list for new sprint",
    type: "Tasks",
    due: "22 Jan 2024",
    owner: "Emma Watson",
    created: "19 Jan 2024",
  },
  {
    title: "Client onboarding meeting completed",
    type: "Meeting",
    due: "25 Jan 2024",
    owner: "Liam Johnson",
    created: "21 Jan 2024",
  },
  {
    title: "Discussed requirements with development team",
    type: "Calls",
    due: "27 Jan 2024",
    owner: "Olivia Smith",
    created: "23 Jan 2024",
  },
  {
    title: "Shared weekly report via email",
    type: "Emails",
    due: "28 Jan 2024",
    owner: "Noah Williams",
    created: "26 Jan 2024",
  },
  {
    title: "Updated CRM records for recent leads",
    type: "Tasks",
    due: "30 Jan 2024",
    owner: "Ava Brown",
    created: "27 Jan 2024",
  },
  ];

  const getBadge = (type) => {
    if (type === "Meeting") return "badge-pink";
    if (type === "Calls") return "badge-purple";
    if (type === "Tasks") return "badge-blue";
    return "badge-yellow";
  };

  const filteredData = data.filter((item) =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Card className="activity-card w-100">
        {/* HEADER */}
        <Card.Header  style={{  background: "#ffffff",  }}  className="header-top">
          <h5>Activity List</h5>

          <div className="filters">
  <div className="date-wrapper" ref={ref}>
      
      {/* Input */}
      <div className="date-box" onClick={() => setOpen(!open)}>
        <input value={dateRange} readOnly />
        <FiCalendar />
      </div>

      {/* Dropdown */}
      {open && (
        <div className="date-dropdown">
          {options.map((item, index) => (
            <div
              key={index}
              className={`date-item ${
                selected.label === item.label ? "active" : ""
              }`}
              onClick={() => {
                setSelected(item);
                setDateRange(item.range); // ✅ UPDATE VALUE
                setOpen(false);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
            <Dropdown>
              <Dropdown.Toggle className="text-dark date-box">
                Activity Type
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Meeting</Dropdown.Item>
                <Dropdown.Item>Calls</Dropdown.Item>
                 <Dropdown.Item>Emails</Dropdown.Item>
                <Dropdown.Item>Tasks</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle className="date-box text-dark">
                Sort By : Last 7 Days
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Recently Added</Dropdown.Item>
                <Dropdown.Item>Ascending</Dropdown.Item>
                 <Dropdown.Item>Descending</Dropdown.Item>
                <Dropdown.Item>Last Month</Dropdown.Item>
                <Dropdown.Item>Last 7 Days</Dropdown.Item>

              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>

        {/* SUB HEADER */}
        <div className="table-top">
          <div className="left">
            Row Per Page
            <Form.Select
              value={rows}
              onChange={(e) => setRows(e.target.value)}
            >
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </Form.Select>
            Entries
          </div>

          <div className="right">
            <input
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* TABLE */}
        <Card.Body className="p-0">
          <Table responsive className="mb-0">
            <thead style={{  background: "#c6c9cc",  }} >
              <tr  style={{  background: "#c6c9cc",  }}  >
                <th><Form.Check /></th>
                <th>Title</th>
                <th>Activity Type</th>
                <th>Due Date</th>
                <th>Owner</th>
                <th>Created Date</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filteredData.slice(0, rows).map((item, i) => (
                <tr key={i}>
                  <td><Form.Check /></td>
                  <td>{item.title}</td>

                  <td>
                    <span className={`badge ${getBadge(item.type)}`}>
                      {item.type}
                    </span>
                  </td>

                  <td>{item.due}</td>
                  <td>{item.owner}</td>
                  <td>{item.created}</td>

                  <td>
                    <div className="action-icons">
                      <FiEdit2 onClick={() => setShowEdit(true)} />
                      <FiTrash2 onClick={() => setShowDelete(true)} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>

        {/* FOOTER */}
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 px-1">

      {/* Left Text */}
      <div className="mb-2 mb-md-0 text-muted">
        Showing {startItem} - {endItem} of {totalItems} entries
      </div>

      {/* Pagination */}
      <Pagination className="mb-0 custom-pagination">

        {/* Previous */}
        <Pagination.Prev
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <FiChevronLeft />
        </Pagination.Prev>

        {/* Page Numbers */}
        {[...Array(totalPages)].map((_, index) => {
          const page = index + 1;
          return (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => goToPage(page)}
              className={page === currentPage ? "active-page" : ""}
            >
              {page}
            </Pagination.Item>
          );
        })}

        {/* Next */}
        <Pagination.Next
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <FiChevronRight />
        </Pagination.Next>
      </Pagination>
    </div>
      </Card>

      {/* MODALS */}
      <EditActivityModal show={showEdit} handleClose={() => setShowEdit(false)} />
      <DeleteModal show={showDelete} handleClose={() => setShowDelete(false)} />

      {/* STYLES */}
      <style>{`
        .activity-card {
     border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:0 2px 5px rgba(0,0,0,0.05);
        }

        .header-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
        }

        .filters {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .btn-white {
          background: white;
          border: 1px solid #ddd;
        }

        .date-box {
          display: flex;
          align-items: center;
          border: 1px solid #ddd;
          padding: 6px 10px;
          border-radius: 6px;
          gap: 5px;
        }

        .table-top {
          display: flex;
          justify-content: space-between;
          padding: 10px 15px;
          border-bottom: 1px solid #eee;
          flex-wrap: wrap;
        }

        .table-top .left {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .table-top select {
          width: 70px;
        }

        .table-top input {
          border: 1px solid #ddd;
          padding: 5px 10px;
          border-radius: 6px;
        }

        .badge {
          padding: 5px 10px;
          border-radius: 6px;
          font-size: 12px;
        }

        .badge-pink { background:#ffe4ec; color:#ff4d88;}
        .badge-purple { background:#f3e8ff; color:#9333ea;}
        .badge-blue { background:#e0f2fe; color:#0284c7;}
        .badge-yellow { background:#fef3c7; color:#d97706;}

        .action-icons {
          display: flex;
          gap: 10px;
          cursor: pointer;
        }

        .table-footer {
          display: flex;
          justify-content: space-between;
          padding: 10px 15px;
          border-top: 1px solid #eee;
        }

        .pagination span {
          margin: 0 5px;
          cursor: pointer;
        }

        /* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;

  border: 1px solid #e5e7eb;
  border-radius: 5px;
  padding: 10px 12px;
  background: #ffffff;
  cursor: pointer;
}
  .date-box:hover{
  background: #ffffff;
  color: #374151;
  border: none;
  outline: none;
  }
  .date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}
        .pagination .active {
          background: #ff6b2c;
          color: white;
          padding: 4px 8px;
          border-radius: 50%;
        }

        @media(max-width:768px){
          .header-top {
            flex-direction: column;
            align-items: flex-start;
          }

          .table-top {
            flex-direction: column;
            gap: 10px;
          }
            
       
        }
          
button,
input,
select,
textarea,
optgroup {
  font-family: 'Roboto', sans-serif;
}
      `}</style>
    </>
  );
};

export default ActivityTable;